export const jackpotsController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'fetchJackpotFeeds',
            cond: 'isJackpotsControllerEnabled',
          },
        ],
      },
    },
    fetchJackpotFeeds: {
      invoke: {
        src: 'fetchJackpotFeeds',
        onDone: [
          {
            actions: ['updateJackpotFeeds'],
            target: 'renderComponent',
          },
        ],
      },
    },
    renderComponent: {
      invoke: {
        src: 'prepareJackpotsContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'controllerIdle',
        },
      },
    },
  },
};
